<template>
  <div v-if="show" class="modal-mask">
    <div class="modal-container">
      <h3 class="modal-title">Selecionar campos para exportar</h3>
      <br />

      <div class="botoes-topo">
        <base-button @click="selecionarTodos">Selecionar Todos</base-button>
        <base-button @click="desmarcarTodos">Desmarcar Todos</base-button>
      </div>

      <div class="campos-container">
        <div
          class="coluna"
          v-for="(grupo, index) in colunasCampos"
          :key="index"
        >
          <div v-for="key in grupo" :key="key" class="campo-checkbox">
            <label>
              <input
                type="checkbox"
                v-model="camposSelecionados"
                :value="key"
              />
              {{ campos[key] }}
            </label>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <base-button
          :disabled="camposSelecionados.length === 0"
          @click="emitirCampos"
          >Exportar</base-button
        >
        <base-button type="danger" @click="$emit('close')"
          >Cancelar</base-button
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: Boolean
  },
  data() {
    return {
      campos: {
        nome: "Nome",
        cpf: "CPF",
        id_empregador: "Empregador",
        hora_limite: "Hora Limite",
        numero_pis: "Número do PIS",
        data_pis: "Data do PIS",
        numero_matricula_ctps: "Matrícula CTPS",
        codigo: "Código",
        endereco_completo: "Endereço",
        email: "E-mail",
        escolaridade: "Escolaridade",
        sexo: "Sexo",
        filiacao_completa: "Filiação",
        data_nascimento: "Nascimento",
        ctps: "CTPS",
        ctps_serie: "Série CTPS",
        expedicao: "Expedição",
        rg: "RG",
        orgao_expeditor: "Órgão Exp.",
        data_expedicao: "Data Expedição",
        titulo_numero: "Título Eleitoral",
        titulo_zona: "Zona",
        titulo_secao: "Seção",
        cert_reservista_ra: "RA Reservista",
        certificado_reservista_categoria: "Categoria Reservista",
        certificado_reservista_serie: "Série Reservista",
        data_adimissao: "Admissão",
        funcao: "Função",
        departamento: "Departamento",
        dt_criacao: "Criação",
        dt_atualizacao: "Atualização",
        tipo_batida: "Tipo Batida"
      },
      camposSelecionados: ["nome", "cpf"]
    };
  },
  computed: {
    colunasCampos() {
      const chaves = Object.keys(this.campos);
      const metade = Math.ceil(chaves.length / 2);
      return [chaves.slice(0, metade), chaves.slice(metade)];
    }
  },
  methods: {
    emitirCampos() {
      this.$emit("exportar", this.mapearCamposParaEnvio());
    },
    selecionarTodos() {
      this.camposSelecionados = Object.keys(this.campos);
    },
    desmarcarTodos() {
      this.camposSelecionados = [];
    },
    mapearCamposParaEnvio() {
      return this.camposSelecionados.flatMap(campo => {
        if (campo === "endereco_completo") {
          return [
            "endereco",
            "complemento",
            "bairro",
            "cep",
            "estado",
            "cidade"
          ];
        }
        if (campo === "filiacao_completa") {
          return ["filiacao_pai", "filiacao_mae"];
        }
        return campo;
      });
    }
  }
};
</script>

<style scoped>
.modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-container {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 500px;
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.modal-title {
  font-size: 18px;
  margin-bottom: 10px;
}
.botoes-topo {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
}
.campos-container {
  display: flex;
  gap: 20px;
  flex: 1;
  overflow-y: auto;
  max-height: 400px;
}
.coluna {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.campo-checkbox {
  display: flex;
  align-items: center;
  gap: 5px;
}
.modal-footer {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}
</style>
